(() => {
  let lastCart = null;
  let pending = null;
  const quantityFor = (cart, id) => cart.items.reduce((sum, item) => sum + (String(item.variant_id || item.id) === id ? item.quantity : 0), 0);
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.action.includes('/cart/add')) return;
    const data = new FormData(form);
    const id = String(data.get('id') || '');
    if (!id || !lastCart) return;
    const previous = form.querySelector('[data-tos-cart-confirmation]');
    if (previous) previous.remove();
    pending = {form, id, before: quantityFor(lastCart, id), time: Date.now()};
  }, true);
  document.addEventListener('theme:cart:change', event => {
    const cart = event.detail && event.detail.cart;
    if (!cart || !Array.isArray(cart.items)) return;
    if (pending && Date.now() - pending.time < 30000 && pending.form.isConnected && quantityFor(cart, pending.id) > pending.before) {
      const status = document.createElement('p');
      status.dataset.tosCartConfirmation = '';
      status.setAttribute('role', 'status');
      status.className = 'tos-cart-confirmation';
      const text = document.createElement('span');
      text.textContent = 'Added to your bag. ';
      const link = document.createElement('a');
      link.href = window.theme.routes.cart;
      link.textContent = 'View bag';
      status.append(text, link);
      pending.form.append(status);
      pending = null;
    }
    lastCart = cart;
  });
})();